/** Locations needed for CRM wrapper processing */
export enum TABLocation {
  Mobi = 538,
  Desktop = 285,
}
